<template>
    <Card class="mb-4 transition-all duration-300 ease-in-out"    :class="{ ' scale-105 shadow-lg': selected }" :style="{'border': selected ? '1px solid '+$getCssVariable('--bs-primary') : '' }">       
        <div class="card-xl-stretch cursor-pointer" @click.prevent="handleClick">
            <a v-if="selected" class="d-block position-relative w-full h-4px" :style="{'border-top-left-radius': '8px', 'border-top-right-radius': '8px', 'background-color':$getCssVariable('--bs-primary')}">
                <div class="triangle" :style="{ 'border-color':$getCssVariable('--bs-primary') + ' transparent transparent transparent'}">
                </div>
            </a>
            <div class=" p-5">
                <span class="fs-2">{{ step?.title }}</span>
                <div class="d-flex justify-content-between align-items-center">
                    <span :title="$t('budgets.total_expense')" class="fw-bold fs-1" :class="overFlowColor">
                        {{formattedLocalAmount(step?.total_expense ) }} {{ iso }}
                     </span>
                    <span ata-bs-toggle="tooltip" data-bs-placement="top" :title="$t('budgets.forecast_budget')" class="fw-bold fs-2">
                        {{formattedLocalAmount(step?.forecast_budget) }} {{ iso }}
                    </span>
                </div>
            </div>
        </div>
    </Card>
</template>

<script setup>
    import {computed,  defineProps} from "vue";
    import Card from '@/components/Card.vue';
    import "vue3-circle-progress/dist/circle-progress.css";
    import { formattedLocalAmount } from "@/mixins/Helpers";

    const model = defineModel()
    const props = defineProps({
        step: {
            type: Object,
            required: true
        },
       iso: {
        type: String,
        default: "xof"
       }
    })

    //const $getCssVariable = (variable) => window.getComputedStyle(document.documentElement).getPropertyValue(variable).trim()

    const selected = computed(() => model.value === props.step?.id)

    const overFlowColor = computed(() => {
        const expense = parseInt(props.step?.total_expense)
        const budget = parseInt(props.step?.forecast_budget)

        if( expense > budget){
            return 'text-danger'
        }else if(expense === budget){
            return 'text-success'
        }

        return "text-primary"
    }) 
    const handleClick = () => {
        model.value = props.step?.id
    }

     
</script>
<style scoped>
.triangle {
    position:relative;
}

.triangle {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 20px 20px 0 0;
  border-top-left-radius: 8px;
 
}

.triangle::after {
  content: "✔";
  position: absolute;
  top: -22px;
  left: 0px;
  color: white;
  font-size: 14px;
  font-weight: bold;
}

</style>